<template>
  <div class="pub-article">
    <div class="label-name" style="background: #fff">写文章</div>
    <div class="from" style="background: #fff; padding: 20px">
      <div class="title-input">
        <a-input
          v-model:value="title"
          placeholder="请输入标题（最多50个字）"
          @change="changeTitle"
          style="border: none; font-size: 18px"
          :maxlength="50"
        />
        <div class="count">{{ title.length }}/50</div>
      </div>

      <div class="tags">
        <span v-show="tags.length > 0">
          <a-badge
            v-for="(tag, index) in tags"
            :key="tag.topicId"
            class="c_tag"
          >
            <template #count>
              <close-circle-filled
                style="color: #e75934"
                @click="handleClose(index)"
              />
            </template>
            <a-button
              type="primary"
              style="border-color: #e8e8e8; color: #333; border-radius: 2px"
              ghost
              >{{ tag.topicName }}</a-button
            >
          </a-badge>
        </span>
        <div class="search">
          <a-input-search
            type="text"
            size="big"
            v-model:value.trim()="tagName"
            placeholder="输入内容"
            @change="changeTagName"
            v-show="tags.length <= 4"
          />
          <div class="list" v-show="tagName.length > 1">
            <div class="create-topic" v-show="showAddNewTopic()">
              创建新话题
              <div class="add" @click="addTopic">
                {{ tagName }}&nbsp;&nbsp;<plus-outlined />
              </div>
            </div>
            <div
              class="item"
              v-for="item in selectList"
              :key="item.topicId"
              @click.stop="selectTag(item)"
            >
              {{ item.topicName }}
            </div>
          </div>
        </div>
        <span v-show="tags.length <= 4"> ({{ tags.length }}/5) </span>
        <div
          class="tips"
          style="display: inline-block; color: #f00; margin-left: 10px"
          v-show="
            tagName.length != 0 && (tagName.length < 2 || tagName.length > 30)
          "
        >
          请输入2~30个字符
        </div>
      </div>
      <vue3-tinymce
        v-model="content"
        :setting="edSetting"
        @change="changeContent"
      />

      <div class="agreement">
        <div>
          <a-checkbox v-model:checked="isNotort"
            >承诺图片、内容、字体不侵权</a-checkbox
          >
        </div>
        <div>
          <a-checkbox v-model:checked="isAgree"
            >同意
            <a
              href="http://test.sozdata.com/agreements.html#/user"
              target="_blank"
              rel="noopener noreferrer"
              style="color: #e75934"
              >《知图投稿协议》</a
            >
          </a-checkbox>
        </div>
      </div>

      <div class="btns">
        <a-button type="default" @click="save">保存草稿</a-button>
        <a-button type="default">
          <router-link
            :to="{ path: '/view/detail', query: { id: id } }"
            target="_blank"
            v-if="id && htmlToText(content) !== ''"
          >
            文章预览
          </router-link>
          <span @click="preview2" v-else>文章预览</span>
        </a-button>
        <a-button type="primary" @click="publish">发布</a-button>
        <div class="tips">
          <router-link
            target="_blank"
            :to="{ path: '/user/articles', query: { id: userId, tab: 3 } }"
          >
            进入草稿箱
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  nextTick,
  defineComponent,
  onMounted,
  onBeforeUnmount,
  computed,
  reactive,
  toRefs,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { PlusOutlined, CloseCircleFilled } from "@ant-design/icons-vue";
import Http from "../until/http";
import Vue3Tinymce from "@jsdawn/vue3-tinymce";
import { debounce } from "lodash-es";
import {
  delSessionItem,
  getSessionItem,
  messageTips,
  setSessionItem,
  htmlToText,
  getCookie,
  getLocalItem,
} from "../until/tools";
import config from "../until/configs";
export default defineComponent({
  components: { PlusOutlined, CloseCircleFilled, Vue3Tinymce },
  setup() {
    let inputRef = ref(null);
    const route = useRoute();
    const router = useRouter();
    const userId = computed(() => {
      let userInfo = getLocalItem("userInfo");
      if (userInfo) {
        return userInfo.userId;
      } else {
        return null;
      }
    });
    const state = reactive({
      id: null,
      title: "",
      tags: [],
      inputVisible: false,
      tagName: "",
      selectList: [],
      content: "",
      tips: "进入草稿箱",
      isNotort: false,
      isAgree: false,
    });
    const edSetting = reactive({
      menubar: false,
      height: 600,
      toolbar:
        "bold italic underline h1 h2 styleselect  blockquote numlist bullist| alignleft aligncenter alignright | link unlink image | hr | removeformat fullscreen",
      plugins: "codesample link image table lists fullscreen hr",
      toolbar_mode: "sliding",
      nonbreaking_force_tab: true,
      relative_urls: false,
      convert_urls: false,
      link_title: false,
      default_link_target: "_blank",
      content_style: "body{font-size: 16px}",
      language: "zh_CN",
      language_url: "http://test.sozdata.com/tinymce_zh_CN.js",
      custom_images_upload: true,
      images_upload_url:
        config.personUploadImage2Pub + "?sid=" + getCookie("z_sid"),
      custom_images_upload_callback: (res) => res.url,
      custom_images_upload_param: { id: "xxxx01", age: 18 },
    });
    const type = computed(() => {
      return route.query.type;
    });

    const handleClose = (index) => {
      state.tags.splice(index, 1);
    };
    const showInput = () => {
      state.inputVisible = true;
      nextTick(() => {
        inputRef.value.focus();
        // state.tagName="";
      });
    };

    const changeTitle = (e) => {
      if (e.target.value.length > 50) {
        Object.assign(state, {
          title: e.target.value.substring(0, 50),
        });
      }
    };

    const selectTag = (item) => {
      let index = -1;
      state.tags.some((value, key) => {
        if (value.topicId === item.topicId) {
          index = key;
          return true;
        }
      });

      if (index === -1) {
        let arr = [...state.tags, item];
        Object.assign(state, { tags: arr });
      }
      setTimeout(() => {
        Object.assign(state, {
          tagName: "",
        });
      }, 30);
      clickEvent();
    };

    const fatch = debounce((value) => {
      Http.searchTopics({ keyword: value }).then((res) => {
        if (res.list) {
          Object.assign(state, {
            selectList: res.list,
          });
        }
      });
    }, 300);

    const changeTagName = () => {
      fatch(state.tagName);
    };

    const changeContent = debounce((value) => {
      // if (value.length < 10) {
      //   return false;
      // }
      Object.assign(state, {
        tips: "草稿保存中……",
      });
      let params = {
        title: state.title ? state.title : htmlToText(value).substring(0, 10),
        summary: htmlToText(value).substring(0, 150),
        content: value,
        type: type.value,
        isPub: -1,
        imgUrl: "",
        topicId: state.tags.map((item) => item.topicId).join(","),
        isNotort: 1,
        isAgree: 1,
      };
      let functionName = "addViewArticle";
      if (state.id) {
        params.essayId = state.id;
        functionName = "updateArticle";
      }
      Http[functionName](params).then((res) => {
        if (res) {
          if (res.success) {
            Object.assign(state, {
              tips: "草稿已保存",
              id: state.id || res.id,
            });
            setSessionItem("article", {
              id: state.id,
              title: params.title,
              content: value,
              tags: state.tags,
            });
          } else {
            Object.assign(state, {
              tips: "草稿保存失败",
            });
          }
        }
      });
    }, 1000);

    const save = () => {
      let params = {
        title: state.title
          ? state.title
          : htmlToText(state.content).substring(0, 10),
        summary: htmlToText(state.content).substring(0, 150),
        content: state.content,
        type: type.value,
        isPub: -1,
        imgUrl: "",
        topicId: state.tags.map((item) => item.topicId).join(","),
        isNotort: 1,
        isAgree: 1,
      };
      let functionName = "addViewArticle";
      if (state.id) {
        params.essayId = state.id;
        functionName = "updateArticle";
      }
      Http[functionName](params).then((res) => {
        if (res) {
          if (res.success) {
            messageTips("草稿已保存", 2);
            Object.assign(state, {
              tips: "草稿已保存",
              id: state.id || res.id,
            });
            setSessionItem("article", {
              id: state.id,
              title: params.title,
              content: state.content,
              tags: state.tags,
            });
          } else {
            Object.assign(state, {
              tips: "草稿保存失败",
            });
          }
        }
      });
    };

    const publish = () => {
      if (state.title === "") {
        messageTips("请输入标题", 2);
        return false;
      }
      if (state.tags.length === 0) {
        messageTips("请添加话题", 2);
        return false;
      }
      if (state.content === "") {
        messageTips("请输入正文内容", 2);
        return false;
      }
      if (!state.isNotort) {
        messageTips("请承诺图片、内容、字体不侵权", 2);
        return false;
      }
      if (!state.isAgree) {
        messageTips("请同意 《知图投稿协议》", 2);
        return false;
      }
      let params = {
        title: state.title,
        summary: htmlToText(state.content).substring(0, 150),
        content: state.content,
        type: type.value,
        isPub: type.value === "2" ? 1 : 0,
        imgUrl: "",
        topicId: state.tags.map((item) => item.topicId).join(","),
        isNotort: 1,
        isAgree: 1,
      };
      let functionName = "addViewArticle";
      if (state.id) {
        params.essayId = state.id;
        functionName = "updateArticle";
      }
      Http[functionName](params).then((res) => {
        if (res) {
          if (res.success) {
            messageTips(res.message, 3);
            Object.assign(state, {
              id: null,
              title: "",
              type: type.value,
              tags: [],
              inputVisible: false,
              tagName: "",
              selectList: [],
              content: "",
              tips: "草稿将自动保存",
              isNotort: false,
              isAgree: false,
            });
            delSessionItem("article");
            if (route.query.id) {
              router.push({ path: "/pub", query: { type: type.value } });
            }
          } else {
            messageTips(res.message, 1);
          }
        }
      });
    };

    const addTopic = () => {
      if (state.tagName.length > 30) {
        messageTips("请输入2~30个字符", 2);
        return false;
      }

      Http.addTopic({ topicName: state.tagName }).then((res) => {
        if (res && res.topicId) {
          state.tags.push({ topicId: res.topicId, topicName: res.topicName });
          state.tags = [
            ...new Set(state.tags.map((e) => JSON.stringify(e))),
          ].map((e) => JSON.parse(e));
        }
      });
      setTimeout(() => {
        Object.assign(state, {
          tagName: "",
        });
      }, 30);
      clickEvent();
    };

    function clickEvent() {
      Object.assign(state, {
        inputVisible: false,
        // tagName: "",
        selectList: [],
      });
    }

    const preview = () => {};
    const preview2 = () => {
      messageTips("预览内容不能为空！", 2);
    };

    const showAddNewTopic = () => {
      let isset = false;
      state.selectList.some((item) => {
        if (item.topicName === state.tagName) {
          isset = true;
          return true;
        }
      });
      return !isset;
    };
    onMounted(() => {
      let sid = getCookie("z_sid");
      if (!sid) {
        router.push("/login");
        return false;
      }
      document.title = "写文章-" + config.siteTitle;
      if (route.query.id) {
        Http.getArticleDetail({ essayId: route.query.id }).then((res) => {
          if (res) {
            Object.assign(state, {
              id: res.essayId ? res.essayId : null,
              title: res.title ? res.title : "",
              tags: res.topicList ? res.topicList : [],
              content: res.content ? res.content : "",
            });
          }
        });
      } else {
        let article = getSessionItem("article");
        if (article) {
          Object.assign(state, {
            id: article.id,
            title: article.title ? article.title : "",
            content: article.content,
            tags: article.tags,
          });
        }
      }
    });

    onBeforeUnmount(() => {
      // document.removeEventListener("click", clickEvent);
      delSessionItem("article");
    });

    return {
      ...toRefs(state),
      handleClose,
      showInput,
      inputRef,
      changeTagName,
      selectTag,
      type,
      edSetting,
      changeContent,
      changeTitle,
      publish,
      save,
      addTopic,
      htmlToText,
      preview,
      preview2,
      showAddNewTopic,
      userId,
    };
  },
});
</script>

<style lang="scss">
.tox-statusbar__branding {
  display: none;
}
.tox .tox-tbtn:focus {
  background: #fff !important;
}
</style>
<style lang="scss" scoped>
@import "../scss/pub-article.scss";
.ant-input {
  background-color: #fff;
}
/deep/.tox .tox-statusbar {
  display: none;
}
</style>